import { hexToRgb } from '../../engine/math';
import type { ChromeTone } from '../../engine/types';

/** Glass and ceramic tesserae, named for where they appear in the design. */
export const MOSAIC_COLORS = {
  mortar: hexToRgb('#3E3833'),
  mortarLight: hexToRgb('#5A524A'),
  chalk: hexToRgb('#E9DFC9'),
  sunWhite: hexToRgb('#FFF1C8'),
  gold: hexToRgb('#F2B632'),
  goldDeep: hexToRgb('#D9982A'),
  amber: hexToRgb('#E8892A'),
  orange: hexToRgb('#D9622B'),
  cobalt: hexToRgb('#1F3D8F'),
  cobaltDeep: hexToRgb('#16285E'),
  indigo: hexToRgb('#1B1F4A'),
  cream: hexToRgb('#F3E6C8'),
  crimson: hexToRgb('#B8283A'),
  rose: hexToRgb('#E0607A'),
  blush: hexToRgb('#F2A3A8'),
  teal: hexToRgb('#1F6E6C'),
  turquoise: hexToRgb('#3FA7A0'),
  aqua: hexToRgb('#7FCBC0'),
  leaf: hexToRgb('#4E9A4E'),
  leafDark: hexToRgb('#2A6234'),
  terracotta: hexToRgb('#C0582E'),
  white: hexToRgb('#F7F2E6'),
  borderRed: hexToRgb('#7E2230'),
};

/**
 * The header sits over dark setting mortar before the pieces arrive and over
 * the deep cobalt and indigo field afterwards, so its text stays white.
 */
export const mosaicChromeTone = (): ChromeTone => 'light';
